// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"k_s","tags__list":"k_K"};